import { Stack } from "@mantine/core";
import { SimpleBreadcrumbs } from "../../components/SimpleBreadcrumbs";
import { useIntl } from "react-intl";
import { PRODUCT } from "@project/common";
import { ContactSalesForm } from "./components/ContactSalesForm";

export const ContactSales = () => {
  const intl = useIntl();
  return (
    <Stack px="md" my="md">
      <SimpleBreadcrumbs
        current={intl.formatMessage({ defaultMessage: "Contact sales", id: "navigation.contactSales" })}
        description={intl.formatMessage({
          defaultMessage: "Learn more about how {project} can help you with your business",
          id: "text.contactSalesDescription",
        }, { project: PRODUCT })}
      />
      <Stack gap="1rem" align="center">
        <Stack maw="1024px" w="100%">
          <ContactSalesForm />
        </Stack>
      </Stack>
    </Stack>
  );
};
